import {createAction} from "redux-act";
import {
	IChecksum,
	ICountry,
	IError,
	IEvent,
	IFaqItem,
	IFetchJSONResponse,
	IHelpPages,
	IHistoricalStats,
	IRider,
} from "modules/types";

export const fetchChecksumsJSON = createAction();
export const fetchChecksumsJSONSuccess = createAction<IChecksum>();
export const fetchChecksumsJSONFailed = createAction<IError>();

// export const fetchConstructorsJSON = createAction();
// export const fetchConstructorsJSONSuccess = createAction<IConstructor[]>();
// export const fetchConstructorsJSONFailed = createAction<IError>();

export const fetchEventsJSON = createAction();
export const fetchEventsJSONSuccess = createAction<IEvent[]>();
export const fetchEventsJSONFailed = createAction<IError>();
//
export const fetchRidersJSON = createAction();
export const fetchRidersJSONSuccess = createAction<IRider[]>();
export const fetchRidersJSONFailed = createAction<IError>();

export const fetchHistoricalStats = createAction();
export const fetchHistoricalSuccess = createAction<IHistoricalStats[]>();

// export const fetchSquadsJSON = createAction();
// export const fetchSquadsJSONSuccess = createAction<ISquad[]>();
// export const fetchSquadsJSONFailed = createAction<IError>();

export const fetchFaq = createAction();
export const fetchFaqSuccess = createAction<IFaqItem[]>();
export const fetchFaqFailed = createAction<IError>();

export const fetchHelpPages = createAction();
export const fetchHelpPagesSuccess = createAction<IHelpPages>();
export const fetchHelpPagesFailed = createAction<IError>();

export const fetchCountries = createAction();
export const fetchCountriesSuccess = createAction<ICountry[]>();
export const fetchCountriesFailed = createAction<IError>();

export const closeInfoBlock = createAction();

export const subscribeToLiveScores = createAction();
export const unsubscribeFromLiveScores = createAction();

export const fetchHelpJSONs = createAction();
export const fetchHelpJSONsSuccess = createAction<IFetchJSONResponse>();
